import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import DashboardSharedTable from '@components/pages/Dashboard/Shared/DashboardSharedTable'
import { huddleYesterdayProviderActualsHasData } from '@utils/dashboardHuddle.util'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import type { HuddleDashboard } from '../useHuddleDashboard'
import { HUDDLE_LEADERBOARD_COLUMNS } from '../huddleLeaderboard.constants'

type ProviderActualsYesterdayCardProps = {
  titleHref: string
  providerActuals: HuddleDashboard['yesterdayProviderActualsApi']
  className?: string
}

export function ProviderActualsYesterdayCard({
  titleHref,
  providerActuals,
  className = 'dashboard-huddle-yesterday-provider-card dashboard-huddle-full-row',
}: ProviderActualsYesterdayCardProps): React.ReactElement {
  const { leaderboardRows, loading, data } = providerActuals
  const isEmpty = shouldShowDashboardSectionEmpty(
    loading,
    huddleYesterdayProviderActualsHasData(data),
  )
  const pending = isDashboardSectionPending(loading, data != null)

  return (
    <DashboardSectionCard
      title="Provider actuals (yesterday)"
      titleHref={titleHref}
      className={className}
      loading={pending}
      skeleton={{ block: 'tall' }}
      isEmpty={isEmpty}
    >
      <div className="dashboard-huddle-leaderboard-table-wrap">
        <DashboardSharedTable
          loading={loading}
          showSearchFilter={false}
          columns={HUDDLE_LEADERBOARD_COLUMNS}
          data={leaderboardRows}
          showPagination={false}
        />
      </div>
    </DashboardSectionCard>
  )
}
